export enum WellnessExamPrognosisScore {
  Grave = 1,
  Poor = 2,
  Fair = 3,
  Good = 4,
  Excellent = 5,
}
